export default {
  init() {
    // JavaScript to be fired on all pages
    $('section').waypoint(function() {
        if($(this.element).attr('id')) {
          var section = $(this.element).attr('id');
          $('.wrap #' + section + ' h2').addClass('animated fadeInDown');
          $('.wrap #' + section + ' h3').addClass('animated fadeInDown');
          $('.wrap #' + section + ' h4').addClass('animated fadeInLeft');
          $('.wrap #' + section + ' h5').addClass('animated fadeInUp');
          $('.wrap #' + section + ' p').addClass('animated fadeInUp');
          $('.wrap #' + section + ' ul').addClass('animated fadeInDown');
          $('#' + section + ' .image-1').addClass('animated fadeIn');
          $('#' + section + ' .card-img-top-holder').addClass('animated fadeIn');
        }

        }, {
            offset: '65%',
    });

    $('h1').lettering('words');

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js